import { AxiosPromise } from 'axios';
import { UserResponse } from 'Models/User';
import { getAxiosInstance } from 'Utils/Http/ApiManager';
import { ApiUrl, getApiUrl } from 'Utils/Http/ApiUrls';

export interface GetUserResponse {
	user: UserResponse;
}
export type GetProfileRequest = (token: string | null) => AxiosPromise<GetUserResponse>;

const getProfile: GetProfileRequest = async (token) => {
	const url = getApiUrl(ApiUrl.Profiles);
	const axios = getAxiosInstance(token);
	return axios.get<GetUserResponse>(url);
};

export default getProfile;
